import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';
import { useMutation } from 'react-query';
import { sendTaskMessageOutbound } from 'RestAPIs/flex-match';
import type { SendTaskMessageOutboundPayload } from 'RestAPIs/flex-match/types';

const useSendTaskMessageOutbound = () => {
  return useMutation(
    (payload: SendTaskMessageOutboundPayload) =>
      sendTaskMessageOutbound(payload),
    {
      onSuccess: () => {
        showSuccessSnackbar();
      },
      onError: () => {
        showErrorSnackbar();
      }
    }
  );
};

export default useSendTaskMessageOutbound;
